import { Briefcase, Home as HomeIcon } from "lucide-react";

export const NEEDS = {
  professionnel: ["Gestion administrative", "Facturation & devis", "Pré-comptabilité", "Assistance RH", "Organisation documentaire", "Dématérialisation", "Suivi d'activité", "Autre besoin"],
  particulier: ["Dossiers administratifs", "Démarches en ligne", "Courriers", "Organisation de documents", "Formalités du quotidien", "Autre besoin"],
};

const CLIENT_TYPES = [
  { value: "professionnel", label: "Professionnel", desc: "Artisan, commerçant, indépendant, TPE, association…", icon: Briefcase },
  { value: "particulier", label: "Particulier", desc: "Démarches et organisation du quotidien", icon: HomeIcon },
];

export const ClientTypeStep = ({ clientType, onSelect }) => (
  <div className="grid gap-5 sm:grid-cols-2">
    {CLIENT_TYPES.map((o) => (
      <button
        key={o.value}
        data-testid={`booking-type-${o.value}`}
        onClick={() => onSelect(o.value)}
        className={`rounded-2xl border-2 p-8 text-left transition-all duration-300 hover:-translate-y-1 ${
          clientType === o.value ? "border-argia-red bg-white shadow-lg" : "border-[#2C2A29]/10 bg-white hover:border-argia-red/40"
        }`}
      >
        <o.icon size={28} strokeWidth={1.5} className={clientType === o.value ? "text-argia-red" : "text-argia-muted"} />
        <p className="mt-4 font-display text-xl font-bold text-argia-ink">{o.label}</p>
        <p className="mt-2 text-sm text-argia-muted">{o.desc}</p>
      </button>
    ))}
  </div>
);

export const NeedsStep = ({ clientType, needs, onToggle }) => (
  <div className="flex flex-wrap justify-center gap-3" data-testid="booking-needs">
    {NEEDS[clientType].map((n) => (
      <button
        key={n}
        data-testid={`need-${n.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
        onClick={() => onToggle(n)}
        className={`rounded-full border px-5 py-2.5 text-sm font-medium transition-all duration-300 ${
          needs.includes(n) ? "border-argia-red bg-argia-red text-white" : "border-[#2C2A29]/15 bg-white text-argia-ink hover:border-argia-red/50"
        }`}
      >
        {n}
      </button>
    ))}
  </div>
);
